module.exports = {
    0: {
        name: "Civerb's Vestments",
        items: [
            "Civerb's Ward",
            "Civerb's Icon",
            "Civerb's Cudgel"
        ]
    },
    1: {
        name: "Hsarus' Defense",
        items: [
            "Hsarus' Iron Heel",
            "Hsarus' Iron Fist",
            "Hsarus' Iron Stay"
        ]
    },
    2: {
        name: "Cleglaw's Brace",
        items: [
            "Cleglaw's Tooth",
            "Cleglaw's Claw",
            "Cleglaw's Pincers"
        ]
    },
    3: {
        name: "Iratha's Finery",
        items: [
            "Iratha's Collar",
            "Iratha's Cuff",
            "Iratha's Coil",
            "Iratha's Cord"
        ]
    },
    4: {
        name: "Isenhart's Armory",
        items: [
            "Isenhart's Lightbrand",
            "Isenhart's Parry",
            "Isenhart's Case",
            "Isenhart's Horns"
        ]
    },
    5: {
        name: "Vidala's Rig",
        items: [
            "Vidala's Barb",
            "Vidala's Fetlock",
            "Vidala's Ambush",
            "Vidala's Snare"
        ]
    },
    6: {
        name: "Milabrega's Regalia",
        items: [
            "Milabrega's Orb",
            "Milabrega's Rod",
            "Milabrega's Diadem",
            "Milabrega's Robe"
        ]
    },
    7: {
        name: "Cathan's Traps",
        items: [
            "Cathan's Rule",
            "Cathan's Mesh",
            "Cathan's Visage",
            "Cathan's Sigil",
            "Cathan's Seal"
        ]
    },
    8: {
        name: "Tancred's Battlegear",
        items: [
            "Tancred's Crowbill",
            "Tancred's Spine",
            "Tancred's Hobnails",
            "Tancred's Weird",
            "Tancred's Skull"
        ]
    },
    9: {
        name: "Sigon's Complete Steel",
        items: [
            "Sigon's Guard",
            "Sigon's Wrap",
            "Sigon's Sabot",
            "Sigon's Gage",
            "Sigon's Shelter",
            "Sigon's Visor"
        ]
    },
    10: {
        name: "Infernal Tools",
        items: [
            "Infernal Cranium",
            "Infernal Torch",
            "Infernal Sign"
        ]
    },
    11: {
        name: "Berserker's Arsenal",
        items: [
            "Berserker's Headgear",
            "Berserker's Hauberk",
            "Berserker's Hatchet"
        ]
    },
    12: {
        name: "Death's Disguise",
        items: [
            "Death's Hand",
            "Death's Guard",
            "Death's Touch"
        ]
    },
    13: {
        name: "Angelic Raiment",
        items: [
            "Angelic Sickle",
            "Angelic Mantle",
            "Angelic Halo",
            "Angelic Wings"
        ]
    },
    14: {
        name: "Arctic Gear",
        items: [
            "Arctic Horn",
            "Arctic Furs",
            "Arctic Binding",
            "Arctic Mitts"
        ]
    },
    15: {
        name: "Arcanna's Tricks",
        items: [
            "Arcanna's Sign",
            "Arcanna's Deathwand",
            "Arcanna's Head",
            "Arcanna's Flesh"
        ]
    },
    16: {
        name: "Natalya's Odium",
        items: [
            "Natalya's Totem",
            "Natalya's Mark",
            "Natalya's Shadow",
            "Natalya's Soul"
        ]
    },
    17: {
        name: "Aldur's Watchtower",
        items: [
            "Aldur's Stony Gaze",
            "Aldur's Deception",
            "Aldur's Rhythm",
            "Aldur's Advance"
        ]
    },
    18: {
        name: "Immortal King",
        items: [
            "Immortal King's Will",
            "Immortal King's Soul Cage",
            "Immortal King's Detail",
            "Immortal King's Forge",
            "Immortal King's Pillar",
            "Immortal King's Stone Crusher"
        ]
    },
    19: {
        name: "Tal Rasha's Wrappings",
        items: [
            "Tal Rasha's Fine Spun Cloth",
            "Tal Rasha's Adjudication",
            "Tal Rasha's Lidless Eye",
            "Tal Rasha's Guardianship",
            "Tal Rasha's Horadric Crest"
        ]
    },
    20: {
        name: "Griswold's Legacy",
        items: [
            "Griswold's Valor",
            "Griswold's Heart",
            "Griswold's Redemption",
            "Griswold's Honor"
        ]
    },
    21: {
        name: "Trang-Oul's Avatar",
        items: [
            "Trang-Oul's Guise",
            "Trang-Oul's Scales",
            "Trang-Oul's Wing",
            "Trang-Oul's Claws",
            "Trang-Oul's Girth"
        ]
    },
    22: {
        name: "M'avina's Battle Hymn",
        items: [
            "M'avina's True Sight",
            "M'avina's Embrace",
            "M'avina's Icy Clutch",
            "M'avina's Tenet",
            "M'avina's Caster"
        ]
    },
    23: {
        name: "The Disciple",
        items: [
            "Telling of Beads",
            "Laying of Hands",
            "Rite of Passage",
            "Dark Adherent",
            "Credendum"
        ]
    },
    24: {
        name: "Heaven's Brethren",
        items: [
            "Dangoon's Teaching",
            "Taebaek's Glory",
            "Haemosu's Adamant",
            "Ondal's Almighty"
        ]
    },
    25: {
        name: "Orphan's Call",
        items: [
            "Guillaume's Face",
            "Wilhelm's Pride",
            "Magnus' Skin",
            "Whitstan's Guard"
        ]
    },
    26: {
        name: "Hwanin's Majesty",
        items: [
            "Hwanin's Splendor",
            "Hwanin's Refuge",
            "Hwanin's Blessing",
            "Hwanin's Justice"
        ]
    },
    27: {
        name: "Sazabi's Grand Tribute",
        items: [
            "Sazabi's Cobalt Redeemer",
            "Sazabi's Ghost Liberator",
            "Sazabi's Mental Sheath"
        ]
    },
    28: {
        name: "Bul-Kathos' Children",
        items: [
            "Bul-Kathos' Sacred Charge",
            "Bul-Kathos' Tribal Guardian"
        ]
    },
    29: {
        name: "Cow King's Leathers",
        items: [
            "Cow King's Horns",
            "Cow King's Hide",
            "Cow King's Hooves"
        ]
    },
    30: {
        name: "Naj's Ancient Vestige",
        items: [
            "Naj's Puzzler",
            "Naj's Light Plate",
            "Naj's Circlet"
        ]
    },
    31: {
        name: "Sander's Folly",
        items: [
            "Sander's Paragon",
            "Sander's Riprap",
            "Sander's Taboo",
            "Sander's Superstition"
        ]
    },
    33: {
        name: "Vibrant Civerb's Vestments",
        items: [
            "Vibrant Civerb's Ward",
            "Vibrant Civerb's Icon",
            "Vibrant Civerb's Cudgel"
        ]
    },
    34: {
        name: "Vibrant Hsarus' Defense",
        items: [
            "Vibrant Hsarus' Iron Heel",
            "Vibrant Hsarus' Iron Fist",
            "Vibrant Hsarus' Iron Stay"
        ]
    },
    35: {
        name: "Vibrant Cleglaw's Brace",
        items: [
            "Vibrant Cleglaw's Tooth",
            "Vibrant Cleglaw's Claw",
            "Vibrant Cleglaw's Pincers"
        ]
    },
    36: {
        name: "Vibrant Isenhart's Armory",
        items: [
            "Vibrant Isenhart's Lightbrand",
            "Vibrant Isenhart's Parry",
            "Vibrant Isenhart's Case",
            "Vibrant Isenhart's Horns"
        ]
    },
    37: {
        name: "Vibrant Vidala's Rig",
        items: [
            "Vibrant Vidala's Barb",
            "Vibrant Vidala's Fetlock",
            "Vibrant Vidala's Ambush",
            "Vibrant Vidala's Snare"
        ]
    },
    38: {
        name: "Vibrant Milabrega's Regalia",
        items: [
            "Vibrant Milabrega's Orb",
            "Vibrant Milabrega's Rod",
            "Vibrant Milabrega's Diadem",
            "Vibrant Milabrega's Robe"
        ]
    },
    39: {
        name: "Vibrant Cathan's Traps",
        items: [
            "Vibrant Cathan's Rule",
            "Vibrant Cathan's Mesh",
            "Vibrant Cathan's Visage",
            "Vibrant Cathan's Sigil",
            "Vibrant Cathan's Seal"
        ]
    },
    40: {
        name: "Vibrant Tancred's Battlegear",
        items: [
            "Vibrant Tancred's Crowbill",
            "Vibrant Tancred's Spine",
            "Vibrant Tancred's Hobnails",
            "Vibrant Tancred's Weird",
            "Vibrant Tancred's Skull"
        ]
    },
    41: {
        name: "Vibrant Sigon's Complete Steel",
        items: [
            "Vibrant Sigon's Guard",
            "Vibrant Sigon's Wrap",
            "Vibrant Sigon's Sabot",
            "Vibrant Sigon's Gage",
            "Vibrant Sigon's Shelter",
            "Vibrant Sigon's Visor"
        ]
    },
    42: {
        name: "Vibrant Berserker's Arsenal",
        items: [
            "Vibrant Berserker's Headgear",
            "Vibrant Berserker's Hauberk",
            "Vibrant Berserker's Hatchet"
        ]
    },
    43: {
        name: "Vibrant Angelic Raiment",
        items: [
            "Vibrant Angelic Sickle",
            "Vibrant Angelic Mantle",
            "Vibrant Angelic Halo",
            "Vibrant Angelic Wings"
        ]
    },
    44: {
        name: "Vibrant Arctic Gear",
        items: [
            "Vibrant Arctic Horn",
            "Vibrant Arctic Furs",
            "Vibrant Arctic Binding",
            "Vibrant Arctic Mitts"
        ]
    },
    45: {
        name: "Vibrant Arcanna's Tricks",
        items: [
            "Vibrant Arcanna's Sign",
            "Vibrant Arcanna's Deathwand",
            "Vibrant Arcanna's Head",
            "Vibrant Arcanna's Flesh"
        ]
    },
    47: {
        name: "Vibrant Natalya's Odium",
        items: [
            "Vibrant Natalya's Totem",
            "Vibrant Natalya's Mark",
            "Vibrant Natalya's Shadow",
            "Vibrant Natalya's Soul"
        ]
    },
    48: {
        name: "Vibrant Aldur's Watchtower",
        items: [
            "Vibrant Aldur's Stony Gaze",
            "Vibrant Aldur's Deception",
            "Vibrant Aldur's Rhythm",
            "Vibrant Aldur's Advance"
        ]
    },
    49: {
        name: "Vibrant Immortal King",
        items: [
            "Vibrant Immortal King's Will",
            "Vibrant Immortal King's Soul Cage",
            "Vibrant Immortal King's Detail",
            "Vibrant Immortal King's Forge",
            "Vibrant Immortal King's Pillar",
            "Vibrant Immortal King's Stone Crusher"
        ]
    },
    50: {
        name: "Vibrant Tal Rasha's Wrappings",
        items: [
            "Vibrant Tal Rasha's Fine Spun Cloth",
            "Vibrant Tal Rasha's Adjudication",
            "Vibrant Tal Rasha's Lidless Eye",
            "Vibrant Tal Rasha's Guardianship",
            "Vibrant Tal Rasha's Horadric Crest"
        ]
    },
    51: {
        name: "Vibrant Griswold's Legacy",
        items: [
            "Vibrant Griswold's Valor",
            "Vibrant Griswold's Heart",
            "Vibrant Griswold's Redemption",
            "Vibrant Griswold's Honor"
        ]
    },
    52: {
        name: "Vibrant Trang-Oul's Avatar",
        items: [
            "Vibrant Trang-Oul's Guise",
            "Vibrant Trang-Oul's Scales",
            "Vibrant Trang-Oul's Wing",
            "Vibrant Trang-Oul's Claws",
            "Vibrant Trang-Oul's Girth"
        ]
    },
    53: {
        name: "Vibrant M'avina's Battle Hymn",
        items: [
            "Vibrant M'avina's True Sight",
            "Vibrant M'avina's Embrace",
            "Vibrant M'avina's Icy Clutch",
            "Vibrant M'avina's Tenet",
            "Vibrant M'avina's Caster"
        ]
    },
    54: {
        name: "Vibrant Orphan's Call",
        items: [
            "Vibrant Guillaume's Face",
            "Vibrant Wilhelm's Pride",
            "Vibrant Magnus' Skin",
            "Vibrant Whitstan's Guard"
        ]
    }
}



// WEBPACK FOOTER //
// ./src/lib/set-map.js